import { render, staticRenderFns } from "./CommonSettings.vue?vue&type=template&id=b05aaa2c&scoped=true&"
import script from "./CommonSettings.vue?vue&type=script&lang=js&"
export * from "./CommonSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b05aaa2c",
  null
  
)

export default component.exports